import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { authReducer } from "./authReducer";
import { userReducer } from "./userReducer";
import { combineReducers } from "redux";
import { adminReducer } from "./admins";
import { logReducer } from "./logReducer";


const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  admins: adminReducer,
  logs: logReducer
});
export default persistReducer(persistConfig, rootReducer);